var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCasesOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Suitcase 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 69",
    d: "M5.83203 12.667C5.83203 11.5624 6.72746 10.667 7.83203 10.667H25.1654C26.2699 10.667 27.1654 11.5624 27.1654 12.667V14.3337C27.1654 15.9905 25.8222 17.3337 24.1654 17.3337H8.83203C7.17518 17.3337 5.83203 15.9905 5.83203 14.3337V12.667Z",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 71",
    d: "M12.5 7.33301C12.5 6.22844 13.3954 5.33301 14.5 5.33301H18.5C19.6046 5.33301 20.5 6.22844 20.5 7.33301V10.6663H12.5V7.33301Z",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 70",
    x: 5.83203,
    y: 10.667,
    width: 21.3333,
    height: 16,
    rx: 2,
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 135",
    d: "M12.5 16V18.6667",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 136",
    d: "M20.5 16V18.6667",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCasesOrange);
export default __webpack_public_path__ + "static/media/icon-cases-orange.6086ce88d25d7a03c044baf90312ae18.svg";
export { ForwardRef as ReactComponent };